import type { ReactNode } from 'react';
import { color } from './tokens';

/** Label on the left, value on the right, ruled below; wraps on narrow screens. */
export function InfoRow({ label, children }: { label: ReactNode; children: ReactNode }) {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 12,
        fontSize: 14,
        padding: '9px 0',
        borderBottom: `1px solid ${color.rowRule}`,
      }}
    >
      <span style={{ color: color.textMuted }}>{label}</span>
      <span style={{ textAlign: 'right' }}>{children}</span>
    </div>
  );
}
